
import { Component, Vue } from 'vue-property-decorator'

/**
 * trタグの基底コンポーネント
 */
@Component
export default class TableRow extends Vue {}
